import api from '../api/api';

const getAllResources = async () => {
  try {
    const response = await api.get('/resources');
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

const getResourceById = async (resourceId) => {
  try {
    const response = await api.get(`/resources/${resourceId}`);
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

const getResourcesByType = async (type) => {
  try {
    const response = await api.get(`/resources/type/${type}`);
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

// UPDATED: Matches the backend endpoint that returns { url: "..." }
const getResourceUrl = async (resourceId) => {
  try {
    const response = await api.get(`/resources/view/${resourceId}`);
    return response.data.data; // Contains { url: "...", expiresInMinutes: ... }
  } catch (error) {
    throw error;
  }
};

const resourceService = {
  getAllResources,
  getResourceById,
  getResourcesByType,
  getResourceUrl,
};

export default resourceService;